import * as THREE from 'three';

const BASE_Y = 0.22;
const FLOOR_STEP = 0.58;
const FLOORS = 4;
const WARP = 0.16;

function normalized(v: number, offset: number): number {
  if (offset === 0) return 0;
  return v / offset;
}

function getFloorIndex(nx: number, nz: number): number {
  const wave = Math.sin(nx * Math.PI * 0.95) * 0.6 + Math.cos(nz * Math.PI * 1.08) * 0.4;
  const t = THREE.MathUtils.clamp((wave + 1) * 0.5, 0, 1);
  return Math.round(t * (FLOORS - 1));
}

export function gridToWorld(col: number, row: number, size: number): THREE.Vector3 {
  const offset = (size - 1) / 2;
  const localX = col - offset;
  const localZ = row - offset;
  const nx = normalized(localX, offset);
  const nz = normalized(localZ, offset);
  const floor = getFloorIndex(nx, nz);
  const y = BASE_Y + (floor - (FLOORS - 1) / 2) * FLOOR_STEP;
  const warp = 1 + (floor / Math.max(1, FLOORS - 1) - 0.5) * WARP;
  return new THREE.Vector3(localX * warp, y, localZ * warp);
}

export function getLayoutHeight(): number {
  return BASE_Y + ((FLOORS - 1) * FLOOR_STEP) / 2;
}
